import React from 'react';
import Box from "@amzn/meridian/box";
import MetricCard from '../MetricCard';
import './ProjectedBacklogCards.scss';
import { BacklogProjections } from "../../pages/reviewAndPublish/model";

export interface ProjectedBacklogCardsStateProps {
    backlogProjections?: BacklogProjections
}

const ProjectedBacklogCards: React.FC<ProjectedBacklogCardsStateProps> = ({
  backlogProjections
}) => {

  const endOfShiftBacklogDiff: number | undefined =
    backlogProjections?.endOfShift?.total !== undefined &&
    backlogProjections?.endOfShift?.alps !== undefined
      ? backlogProjections.endOfShift.total - backlogProjections.endOfShift.alps
      : undefined;

  const endOfWeekBacklogDiff: number | undefined =
    backlogProjections?.endOfWeek?.total !== undefined &&
    backlogProjections?.endOfWeek?.alps !== undefined
      ? backlogProjections.endOfWeek.total - backlogProjections.endOfWeek.alps
      : undefined;

  return (
    <Box className="projected-backlog-cards">
      <MetricCard
        title="Projected End of Shift Backlog"
        value={backlogProjections?.endOfShift?.total ?? "--"}
        unit={"units"}
        valueDiff={endOfShiftBacklogDiff}
        subtext={"units vs. ALPS"}
        subtextColor={endOfShiftBacklogDiff ? (endOfShiftBacklogDiff>0 ? 'success' : 'error') : undefined}
        valueColor="primary"
        className="projected-backlog-cards__card"
        size="medium"
      />
      
      <MetricCard
        title="Projected End of Week Backlog"
        value={backlogProjections?.endOfWeek?.total ?? "--"}
        unit={"units"}
        valueDiff={endOfShiftBacklogDiff}
        subtext={"units vs. ALPS"}
        subtextColor={endOfWeekBacklogDiff ? (endOfWeekBacklogDiff>0 ? 'success' : 'error') : undefined}
        valueColor="primary"
        className="projected-backlog-cards__card"
        size="medium"
      />
    </Box>
  );
};

export default ProjectedBacklogCards;
